import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { SvgIcon } from "@mui/material";
export var PlusBlueIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.99935 4.16797V15.8346M4.16602 10.0013H15.8327",
        stroke: "blue",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var EyeIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, _extends({}, props, {
        sx: _objectSpread({}, props.sx)
    }), /*#__PURE__*/ React.createElement("svg", {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2.51677 10.5946C2.40328 10.4149 2.34654 10.3251 2.31477 10.1865C2.29091 10.0824 2.29091 9.91824 2.31477 9.81415C2.34654 9.67556 2.40328 9.58571 2.51677 9.40601C3.45461 7.92103 6.24617 4.16699 10.5003 4.16699C14.7545 4.16699 17.5461 7.92103 18.4839 9.40601C18.5974 9.58571 18.6541 9.67556 18.6859 9.81415C18.7098 9.91824 18.7098 10.0824 18.6859 10.1865C18.6541 10.3251 18.5974 10.4149 18.4839 10.5946C17.5461 12.0796 14.7545 15.8337 10.5003 15.8337C6.24617 15.8337 3.45461 12.0796 2.51677 10.5946Z",
        stroke: "#6A7682",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.5003 12.5003C11.881 12.5003 13.0003 11.381 13.0003 10.0003C13.0003 8.61961 11.881 7.50033 10.5003 7.50033C9.11962 7.50033 8.00034 8.61961 8.00034 10.0003C8.00034 11.381 9.11962 12.5003 10.5003 12.5003Z",
        stroke: "#6A7682",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var MailGrayIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, _extends({}, props, {
        sx: _objectSpread({}, props.sx)
    }), /*#__PURE__*/ React.createElement("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1.16602 3.08203L5.92888 6.41604C6.31457 6.68602 6.50741 6.82101 6.71717 6.87329C6.90245 6.91948 7.09624 6.91948 7.28153 6.87329C7.49129 6.82101 7.68413 6.68602 8.06981 6.41604L12.8327 3.08203M3.96602 10.6654H10.0327C11.0128 10.6654 11.5028 10.6654 11.8772 10.4746C12.2064 10.3068 12.4742 10.0391 12.6419 9.70985C12.8327 9.3355 12.8327 8.84546 12.8327 7.86536V4.13203C12.8327 3.15194 12.8327 2.66189 12.6419 2.28755C12.4742 1.95826 12.2064 1.69055 11.8772 1.52277C11.5028 1.33203 11.0128 1.33203 10.0327 1.33203H3.96602C2.98592 1.33203 2.49588 1.33203 2.12153 1.52277C1.79225 1.69055 1.52453 1.95826 1.35675 2.28755C1.16602 2.66189 1.16602 3.15194 1.16602 4.13203V7.86536C1.16602 8.84546 1.16602 9.3355 1.35675 9.70985C1.52453 10.0391 1.79225 10.3068 2.12153 10.4746C2.49588 10.6654 2.98592 10.6654 3.96602 10.6654Z",
        stroke: "#6A7682",
        "stroke-width": "1.3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var MarkerPin = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, _extends({}, props, {
        sx: _objectSpread({}, props.sx)
    }), /*#__PURE__*/ React.createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.00065 7.58464C7.96715 7.58464 8.75065 6.80113 8.75065 5.83464C8.75065 4.86814 7.96715 4.08464 7.00065 4.08464C6.03415 4.08464 5.25065 4.86814 5.25065 5.83464C5.25065 6.80113 6.03415 7.58464 7.00065 7.58464Z",
        stroke: "#6A7682",
        "stroke-width": "1.3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.00065 12.8346C9.33398 10.5013 11.6673 8.41196 11.6673 5.83464C11.6673 3.25731 9.57798 1.16797 7.00065 1.16797C4.42332 1.16797 2.33398 3.25731 2.33398 5.83464C2.33398 8.41196 4.66732 10.5013 7.00065 12.8346Z",
        stroke: "#6A7682",
        "stroke-width": "1.3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var CheckVerified = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, _extends({}, props, {
        sx: _objectSpread({}, props.sx)
    }), /*#__PURE__*/ React.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.01575 6C1.0156 5.93309 1.00246 5.86625 0.976325 5.80326L0.615605 4.92988C0.539397 4.74594 0.500032 4.54849 0.5 4.3494C0.499968 4.15019 0.539188 3.95293 0.615419 3.76888C0.691651 3.58484 0.803399 3.41761 0.944281 3.27677C1.08512 3.13597 1.25233 3.02429 1.43633 2.94811L2.3083 2.58692C2.43458 2.5347 2.5353 2.43443 2.58787 2.3083L2.94915 1.43607C3.10304 1.06453 3.39822 0.76933 3.76976 0.615427C4.1413 0.461524 4.55876 0.461524 4.93031 0.615427L5.80186 0.976452C5.92834 1.02867 6.07051 1.0286 6.19689 0.976155L6.19788 0.975744L7.07021 0.615958C7.44162 0.462265 7.85917 0.462214 8.23054 0.616046C8.60201 0.769918 8.89715 1.06503 9.05106 1.43648L9.40367 2.28776C9.4068 2.29448 9.40979 2.3013 9.41265 2.30821C9.46492 2.43462 9.56521 2.53512 9.6915 2.58765L10.564 2.94905C10.9355 3.10295 11.2307 3.39815 11.3846 3.76969C11.5385 4.14124 11.5385 4.5587 11.3846 4.93024L11.0234 5.80224C10.9972 5.86557 10.9841 5.93304 10.984 6.00015C10.9841 6.06726 10.9972 6.13443 11.0234 6.19776L11.3846 7.06976C11.5385 7.4413 11.5385 7.85876 11.3846 8.23031C11.2307 8.60185 10.9355 8.89705 10.564 9.05095L9.6915 9.41235C9.56521 9.46488 9.46492 9.56538 9.41265 9.69179C9.40979 9.6987 9.4068 9.70552 9.40367 9.71224L9.05106 10.5635C8.89715 10.935 8.60201 11.2301 8.23054 11.384C7.85917 11.5378 7.44162 11.5377 7.07021 11.384L6.19788 11.0243L6.19689 11.0238C6.07051 10.9714 5.92834 10.9713 5.80186 11.0235L4.93031 11.3846C4.55876 11.5385 4.1413 11.5385 3.76976 11.3846C3.39822 11.2307 3.10304 10.9355 2.94915 10.5639L2.58787 9.6917C2.5353 9.56557 2.43458 9.4653 2.3083 9.41308L1.43633 9.05189C1.25233 8.97571 1.08512 8.86403 0.944281 8.72323C0.803399 8.58239 0.691651 8.41516 0.615419 8.23112C0.539188 8.04707 0.499968 7.84981 0.5 7.6506C0.500032 7.45151 0.539397 7.25406 0.615605 7.07012L0.976325 6.19674C1.00246 6.13375 1.0156 6.06691 1.01575 6ZM8.10355 5.10355C8.29882 4.90829 8.29882 4.59171 8.10355 4.39645C7.90829 4.20118 7.59171 4.20118 7.39645 4.39645L5.5 6.29289L4.85355 5.64645C4.65829 5.45118 4.34171 5.45118 4.14645 5.64645C3.95118 5.84171 3.95118 6.15829 4.14645 6.35355L5.14645 7.35355C5.34171 7.54882 5.65829 7.54882 5.85355 7.35355L8.10355 5.10355Z",
        fill: "#3697FF"
    })));
};
export var DisabledPlusIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, _extends({}, props, {
        sx: _objectSpread({}, props.sx)
    }), /*#__PURE__*/ React.createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.0013 1.16797V12.8346M1.16797 7.0013H12.8346",
        stroke: "#A8B5C2",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var PlusIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.99935 4.16797V15.8346M4.16602 10.0013H15.8327",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var TrashIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, _extends({}, props, {
        sx: _objectSpread({
            opacity: 0.5
        }, props.sx)
    }), /*#__PURE__*/ React.createElement("svg", {
        width: "18",
        height: "20",
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.3333 5.0013V4.33464C12.3333 3.40121 12.3333 2.9345 12.1517 2.57798C11.9919 2.26438 11.7369 2.00941 11.4233 1.84962C11.0668 1.66797 10.6001 1.66797 9.66667 1.66797H8.33333C7.39991 1.66797 6.9332 1.66797 6.57668 1.84962C6.26308 2.00941 6.00811 2.26438 5.84832 2.57798C5.66667 2.9345 5.66667 3.40121 5.66667 4.33464V5.0013M1.5 5.0013H16.5M14.8333 5.0013V14.3346C14.8333 15.7348 14.8333 16.4348 14.5608 16.9696C14.3212 17.44 13.9387 17.8225 13.4683 18.0622C12.9335 18.3346 12.2335 18.3346 10.8333 18.3346H7.16667C5.76654 18.3346 5.06647 18.3346 4.53169 18.0622C4.06129 17.8225 3.67883 17.44 3.43915 16.9696C3.16667 16.4348 3.16667 15.7348 3.16667 14.3346V5.0013",
        stroke: "#6A7682",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var DisabledTrashIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, _extends({}, props, {
        sx: _objectSpread({
            opacity: 0.5
        }, props.sx)
    }), /*#__PURE__*/ React.createElement("svg", {
        width: "18",
        height: "20",
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.3333 5.0013V4.33464C12.3333 3.40121 12.3333 2.9345 12.1517 2.57798C11.9919 2.26438 11.7369 2.00941 11.4233 1.84962C11.0668 1.66797 10.6001 1.66797 9.66667 1.66797H8.33333C7.39991 1.66797 6.9332 1.66797 6.57668 1.84962C6.26308 2.00941 6.00811 2.26438 5.84832 2.57798C5.66667 2.9345 5.66667 3.40121 5.66667 4.33464V5.0013M1.5 5.0013H16.5M14.8333 5.0013V14.3346C14.8333 15.7348 14.8333 16.4348 14.5608 16.9696C14.3212 17.44 13.9387 17.8225 13.4683 18.0622C12.9335 18.3346 12.2335 18.3346 10.8333 18.3346H7.16667C5.76654 18.3346 5.06647 18.3346 4.53169 18.0622C4.06129 17.8225 3.67883 17.44 3.43915 16.9696C3.16667 16.4348 3.16667 15.7348 3.16667 14.3346V5.0013",
        stroke: "#A8B5C2",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var DotsVerticalIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.33398 10C8.33398 9.07952 9.08018 8.33333 10.0007 8.33333C10.9211 8.33333 11.6673 9.07952 11.6673 10C11.6673 10.9205 10.9211 11.6667 10.0007 11.6667C9.08018 11.6667 8.33398 10.9205 8.33398 10Z",
        fill: "#6A7682"
    }), /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.33398 4.16667C8.33398 3.24619 9.08018 2.5 10.0007 2.5C10.9211 2.5 11.6673 3.24619 11.6673 4.16667C11.6673 5.08714 10.9211 5.83333 10.0007 5.83333C9.08018 5.83333 8.33398 5.08714 8.33398 4.16667Z",
        fill: "#6A7682"
    }), /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.33398 15.8333C8.33398 14.9129 9.08018 14.1667 10.0007 14.1667C10.9211 14.1667 11.6673 14.9129 11.6673 15.8333C11.6673 16.7538 10.9211 17.5 10.0007 17.5C9.08018 17.5 8.33398 16.7538 8.33398 15.8333Z",
        fill: "#6A7682"
    })));
};
export var FeatureIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "48",
        height: "49",
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 24.5C0 11.2452 10.7452 0.5 24 0.5C37.2548 0.5 48 11.2452 48 24.5C48 37.7548 37.2548 48.5 24 48.5C10.7452 48.5 0 37.7548 0 24.5Z",
        fill: "#FFEECC"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M24 20.5V24.5M24 28.5H24.01M34 24.5C34 30.0228 29.5228 34.5 24 34.5C18.4772 34.5 14 30.0228 14 24.5C14 18.9772 18.4772 14.5 24 14.5C29.5228 14.5 34 18.9772 34 24.5Z",
        stroke: "#CC7A00",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var EditIcon = function (props) {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        "clip-path": "url(#clip0_3421_64100)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.16602 3.33027H5.66602C4.26588 3.33027 3.56582 3.33027 3.03104 3.60275C2.56063 3.84244 2.17818 4.22489 1.9385 4.69529C1.66602 5.23007 1.66602 5.93014 1.66602 7.33027V14.3303C1.66602 15.7304 1.66602 16.4305 1.9385 16.9652C2.17818 17.4356 2.56063 17.8181 3.03104 18.0578C3.56582 18.3303 4.26588 18.3303 5.66602 18.3303H12.666C14.0661 18.3303 14.7662 18.3303 15.301 18.0578C15.7714 17.8181 16.1538 17.4356 16.3935 16.9652C16.666 16.4305 16.666 15.7304 16.666 14.3303V10.8303M6.66599 13.3303H8.06145C8.4691 13.3303 8.67292 13.3303 8.86474 13.2842C9.0348 13.2434 9.19737 13.176 9.34649 13.0847C9.51468 12.9816 9.65881 12.8375 9.94706 12.5492L17.916 4.58027C18.6064 3.88991 18.6064 2.77062 17.916 2.08027C17.2257 1.38991 16.1064 1.38991 15.416 2.08027L7.44704 10.0492C7.15879 10.3375 7.01466 10.4816 6.91159 10.6498C6.82021 10.7989 6.75287 10.9615 6.71204 11.1315C6.66599 11.3234 6.66599 11.5272 6.66599 11.9348V13.3303Z",
        stroke: "#0052ff",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_3421_64100"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white"
    }))));
};
export var LinkIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.49935 14.1654H5.83268C3.5315 14.1654 1.66602 12.2999 1.66602 9.9987C1.66602 7.69751 3.5315 5.83203 5.83268 5.83203H7.49935M12.4993 14.1654H14.166C16.4672 14.1654 18.3327 12.2999 18.3327 9.9987C18.3327 7.69751 16.4672 5.83203 14.166 5.83203H12.4993M5.83268 9.9987L14.166 9.9987",
        stroke: "#EB6A2C",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var PrintIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        "clip-path": "url(#clip0_2334_32162)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.9993 5.83464V4.33464C14.9993 3.40121 14.9993 2.9345 14.8177 2.57798C14.6579 2.26438 14.4029 2.00941 14.0893 1.84962C13.7328 1.66797 13.2661 1.66797 12.3327 1.66797H7.66602C6.7326 1.66797 6.26588 1.66797 5.90937 1.84962C5.59576 2.00941 5.34079 2.26438 5.18101 2.57798C4.99935 2.9345 4.99935 3.40121 4.99935 4.33464V5.83464M4.99935 15.0013C4.22437 15.0013 3.83688 15.0013 3.51897 14.9161C2.65624 14.6849 1.98237 14.0111 1.7512 13.1483C1.66602 12.8304 1.66602 12.4429 1.66602 11.668V9.83464C1.66602 8.4345 1.66602 7.73444 1.9385 7.19966C2.17818 6.72925 2.56063 6.3468 3.03104 6.10712C3.56582 5.83464 4.26588 5.83464 5.66602 5.83464H14.3327C15.7328 5.83464 16.4329 5.83464 16.9677 6.10712C17.4381 6.3468 17.8205 6.72925 18.0602 7.19966C18.3327 7.73444 18.3327 8.4345 18.3327 9.83464V11.668C18.3327 12.4429 18.3327 12.8304 18.2475 13.1483C18.0163 14.0111 17.3425 14.6849 16.4797 14.9161C16.1618 15.0013 15.7743 15.0013 14.9993 15.0013M12.4993 8.7513H14.9993M7.66602 18.3346H12.3327C13.2661 18.3346 13.7328 18.3346 14.0893 18.153C14.4029 17.9932 14.6579 17.7382 14.8177 17.4246C14.9994 17.0681 14.9993 16.6014 14.9993 15.668V14.3346C14.9993 13.4012 14.9994 12.9345 14.8177 12.578C14.6579 12.2644 14.4029 12.0094 14.0893 11.8496C13.7328 11.668 13.2661 11.668 12.3327 11.668H7.66602C6.7326 11.668 6.26588 11.668 5.90937 11.8496C5.59576 12.0094 5.34079 12.2644 5.18101 12.578C4.99935 12.9345 4.99935 13.4012 4.99935 14.3346V15.668C4.99935 16.6014 4.99935 17.0681 5.18101 17.4246C5.34079 17.7382 5.59576 17.9932 5.90937 18.153C6.26588 18.3346 6.73259 18.3346 7.66602 18.3346Z",
        stroke: "#6A7682",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_2334_32162"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white"
    })))));
};
export var DownloadIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M17.5 12.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V12.5M14.1667 8.33333L10 12.5M10 12.5L5.83333 8.33333M10 12.5V2.5",
        stroke: "#6A7682",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var UploadIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1.66602 2.5013C1.66602 2.04106 2.03911 1.66797 2.49935 1.66797H17.4993C17.9596 1.66797 18.3327 2.04106 18.3327 2.5013C18.3327 2.96154 17.9596 3.33464 17.4993 3.33464H2.49935C2.03911 3.33464 1.66602 2.96154 1.66602 2.5013Z",
        fill: "#EB6A2C"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.41009 11.4239C4.73553 11.7493 5.26317 11.7493 5.5886 11.4239L9.16602 7.84648L9.16602 17.5013C9.16602 17.9615 9.53911 18.3346 9.99935 18.3346C10.4596 18.3346 10.8327 17.9615 10.8327 17.5013L10.8327 7.84648L14.4101 11.4239C14.7355 11.7493 15.2632 11.7493 15.5886 11.4239C15.914 11.0985 15.914 10.5708 15.5886 10.2454L10.5886 5.24538C10.2632 4.91994 9.73553 4.91994 9.41009 5.24538L4.41009 10.2454C4.08466 10.5708 4.08466 11.0985 4.41009 11.4239Z",
        fill: "#EB6A2C"
    })));
};
export var EXLIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M30.5996 10.6485V28.8C30.5996 30.2359 29.4355 31.4 27.9996 31.4H8.79961C7.36367 31.4 6.19961 30.2359 6.19961 28.8V3.2C6.19961 1.76406 7.36367 0.6 8.79961 0.6H20.5511L30.5996 10.6485Z",
        stroke: "#DEE4EB",
        "stroke-width": "1.2"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M20.8008 0.800781V7.20078C20.8008 8.96809 22.2335 10.4008 24.0008 10.4008H30.4008",
        stroke: "#DEE4EB",
        "stroke-width": "1.2"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M0.800781 15.9984C0.800781 15.1148 1.51713 14.3984 2.40078 14.3984H18.0008C18.8844 14.3984 19.6008 15.1148 19.6008 15.9984V25.5984C19.6008 26.4821 18.8844 27.1984 18.0008 27.1984H2.40078C1.51713 27.1984 0.800781 26.4821 0.800781 25.5984V15.9984Z",
        fill: "#52C41A"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.19317 24.2969H3.94517V18.5849H7.19317V19.4409H4.96917V20.8969H7.04917V21.7529H4.96917V23.4329H7.19317V24.2969ZM12.7421 24.2969H11.5741L10.1741 22.0169L8.76611 24.2969H7.67811L9.57411 21.3369L7.79811 18.5849H8.92611L10.2221 20.7129L11.5101 18.5849H12.6061L10.8221 21.3769L12.7421 24.2969ZM13.492 24.2969V18.5849H14.516V23.4329H16.9V24.2969H13.492Z",
        fill: "white"
    })));
};
export var DeleteIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M21.3333 13.0013V12.3346C21.3333 11.4012 21.3333 10.9345 21.1517 10.578C20.9919 10.2644 20.7369 10.0094 20.4233 9.84962C20.0668 9.66797 19.6001 9.66797 18.6667 9.66797H17.3333C16.3999 9.66797 15.9332 9.66797 15.5767 9.84962C15.2631 10.0094 15.0081 10.2644 14.8483 10.578C14.6667 10.9345 14.6667 11.4012 14.6667 12.3346V13.0013M16.3333 17.5846V21.7513M19.6667 17.5846V21.7513M10.5 13.0013H25.5M23.8333 13.0013V22.3346C23.8333 23.7348 23.8333 24.4348 23.5608 24.9696C23.3212 25.44 22.9387 25.8225 22.4683 26.0622C21.9335 26.3346 21.2335 26.3346 19.8333 26.3346H16.1667C14.7665 26.3346 14.0665 26.3346 13.5317 26.0622C13.0613 25.8225 12.6788 25.44 12.4392 24.9696C12.1667 24.4348 12.1667 23.7348 12.1667 22.3346V13.0013",
        stroke: "#6A7682",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var GrayDeleteIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "17",
        height: "20",
        viewBox: "0 0 17 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1 4.97786H2.66667M2.66667 4.97786H16M2.66667 4.97786V16.6445C2.66667 17.0866 2.84226 17.5105 3.15482 17.823C3.46738 18.1356 3.89131 18.3112 4.33333 18.3112H12.6667C13.1087 18.3112 13.5326 18.1356 13.8452 17.823C14.1577 17.5105 14.3333 17.0866 14.3333 16.6445V4.97786H2.66667ZM5.16667 4.97786V3.3112C5.16667 2.86917 5.34226 2.44525 5.65482 2.13269C5.96738 1.82013 6.39131 1.64453 6.83333 1.64453H10.1667C10.6087 1.64453 11.0326 1.82013 11.3452 2.13269C11.6577 2.44525 11.8333 2.86917 11.8333 3.3112V4.97786M6.83333 9.14453V14.1445M10.1667 9.14453V14.1445",
        stroke: "#8593A3",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var searchIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.16699 0.667969C4.02486 0.667969 0.666992 4.02583 0.666992 8.16797C0.666992 12.3101 4.02486 15.668 8.16699 15.668C9.93784 15.668 11.5653 15.0542 12.8484 14.0279L15.9111 17.0906C16.2365 17.416 16.7641 17.416 17.0896 17.0906C17.415 16.7651 17.415 16.2375 17.0896 15.912L14.0269 12.8494C15.0533 11.5663 15.667 9.93881 15.667 8.16797C15.667 4.02583 12.3091 0.667969 8.16699 0.667969ZM2.33366 8.16797C2.33366 4.94631 4.94533 2.33464 8.16699 2.33464C11.3887 2.33464 14.0003 4.94631 14.0003 8.16797C14.0003 11.3896 11.3887 14.0013 8.16699 14.0013C4.94533 14.0013 2.33366 11.3896 2.33366 8.16797Z",
        fill: "#6A7682"
    })));
};
export var CrossIcon = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15 5.97852L5 15.9785M5 5.97852L15 15.9785",
        stroke: "#6A7682",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
